import { render, staticRenderFns } from "./chat-details.vue?vue&type=template&id=142b4891&"
import script from "./chat-details.vue?vue&type=script&lang=js&"
export * from "./chat-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports